import type { TAsyncState, TCreateSlice } from "@/store";

import type { TApiAps } from "@/apis/proda/aps";

type TDataGovernance = { enabledDbIds: number[]; hasAccess: boolean };

type TStateAps = {
    dataGovernanceState: TAsyncState<TDataGovernance, unknown>;
};

type TActionsPublicAps = {
    refreshDataGovernance: (userSelectedDatabases: number[]) => Promise<void>;
    resetStateAps: () => void;
};

export type TSliceAps = TStateAps & TActionsPublicAps;

type TSliceDependenciesAps = {
    apiAps: Pick<TApiAps, "getDataGovernanceEnabledDatabases">;
};

export const initialStateAps = {
    dataGovernanceState: {
        status: "idle",
        data: null,
        error: null,
    },
} as const satisfies TStateAps;

export const createSliceAps: TCreateSlice<TSliceAps, TSliceDependenciesAps> =
    ({ apiAps }) =>
    set => {
        const refreshDataGovernance = async () => {
            set(
                {
                    dataGovernanceState: {
                        status: "pending",
                        data: null,
                        error: null,
                    },
                },
                false,
                "aps/refreshDataGovernance/pending",
            );
            try {
                const enabledIds =
                    await apiAps.getDataGovernanceEnabledDatabases();
                set(
                    {
                        dataGovernanceState: {
                            status: "resolved",
                            data: {
                                enabledDbIds: enabledIds,
                                hasAccess: enabledIds.length > 0,
                            },
                            error: null,
                        },
                    },
                    false,
                    "aps/refreshDataGovernance/resolved",
                );
            } catch (error) {
                set(
                    {
                        dataGovernanceState: {
                            status: "rejected",
                            data: null,
                            error,
                        },
                    },
                    false,
                    "aps/refreshDataGovernance/rejected",
                );
            }
        };

        const resetStateAps = () => {
            set(initialStateAps, false, "aps/resetState");
        };

        return {
            ...initialStateAps,
            refreshDataGovernance,
            resetStateAps,
        };
    };
